import { createContext } from "react"
import { T区分マスタ } from "./ComboBox/KubunComboBox"

/**
 * 区分データ用Context
 */
export const KubunContext = createContext<T区分マスタ[]>([] as T区分マスタ[])

//#region グリッドを別コンポーネントに分割した場合に利用するcontext群

/**
 * ContextでuseStateを利用する場合の型定義
 */
export type ReactUseState<T> = {
  state: T
  setState: React.Dispatch<React.SetStateAction<T>>
}

export const IsPromptRefContext = createContext<
  React.MutableRefObject<boolean>
>({} as React.MutableRefObject<boolean>)

/**
 * 検索状態伝播用Context
 */
export const IsSearchingContext = createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

/**
 * 復元中状態伝播用Context
 */
export const IsRestoreSearchingContext = createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

/**
 * グリッド初期化確認用Context
 */
export const GridInitializedContext = createContext<ReactUseState<boolean>>(
  {} as ReactUseState<boolean>
)

/**
 * ファンクション伝播用Context
 */
export const FunctionContext = createContext<Function>(() => {})
//#endregion
